export default __webpack_public_path__ + "static/media/haydenClick.4e5af3ad.png";